// extracted by mini-css-extract-plugin
export var dark = "hubspot-form-module--dark--a8d52";
export var gridContainer = "hubspot-form-module--gridContainer--15ed8";
export var headline = "hubspot-form-module--headline--9fb8c";
export var hubspotForm = "hubspot-form-module--hubspotForm--9f630";
export var light = "hubspot-form-module--light--9b8ca";
export var singleLineForm = "hubspot-form-module--singleLineForm--0fe55";
export var subHeadline = "hubspot-form-module--subHeadline--8161b";